export class Constants {
  public  menuList = [{
    nombre: 'Suministros', backendNombre: 'AltasSuministros', icono: '../assets/resources/icons-menu/suministros.svg', items: [
      {nombre: 'Alta de Luz', icono: '../assets/resources/icons-submenu/icon1_24.svg'},
      {nombre: 'Alta de Agua', icono: '../assets/resources/icons-submenu/icon1_25.svg'},
      {nombre: 'Alta de Gas', icono: '../assets/resources/icons-submenu/icon1_26.svg'}
    ]},
    {nombre: 'Acabados', backendNombre: 'Acabados', icono: '../assets/resources/icons-menu/acabados.svg', items: [
      {nombre: 'Pavimento de vivienda', icono: '../assets/resources/icons-submenu/icon1_01.svg'},
      {nombre: 'Solados y alicatados', icono: '../assets/resources/icons-submenu/icon1_02.svg'},
      {nombre: 'Pintura', icono: '../assets/resources/icons-submenu/icon1_03.svg'},
      {nombre: 'Carpintería de madera', icono: '../assets/resources/icons-submenu/icon1_04.svg'},
      {nombre: 'Carpintería de aluminio', icono: '../assets/resources/icons-submenu/icon1_05.svg'},
      {nombre: 'Sanitarios y grifería', icono: '../assets/resources/icons-submenu/icon1_06.svg'},
      {nombre: 'Tabiquería y falso techo', icono: '../assets/resources/icons-submenu/icon1_07.svg'}
    ]},
    {nombre: 'Instalaciones', backendNombre: 'Instalaciones', icono: '../assets/resources/icons-menu/instalaciones.svg', items: [
      {nombre: 'Climatización', icono: '../assets/resources/icons-submenu/icon1_08.svg'},
      {nombre: 'Fontanería y saneamiento', icono: '../assets/resources/icons-submenu/icon1_09.svg'},
      {nombre: 'Calefacción', icono: '../assets/resources/icons-submenu/icon1_22.svg'},
      {nombre: 'Electricidad', icono: '../assets/resources/icons-submenu/icon1_23.svg'},
      {nombre: 'Telecomunicaciones', icono: '../assets/resources/icons-submenu/icon1_10.svg'},
      {nombre: 'Instalación ventilación mecánica', icono: '../assets/resources/icons-submenu/icon1_11.svg'}
    ]},
    {nombre: 'Mobiliario cocina', backendNombre: 'MobiliarioDeCocina', icono: '../assets/resources/icons-menu/mobiliario-cocina.svg', items: [
      {nombre: 'Electrodomésticos', icono: '../assets/resources/icons-submenu/icon1_12.svg'}
    ]},
    {nombre: 'Conservación', backendNombre: 'Conservacion', icono: '../assets/resources/icons-menu/conservacion.svg', items: [
      {nombre: 'Instalaciones', icono: '../assets/resources/icons-submenu/icon1_13.svg'},
      {nombre: 'Acabados', icono: '../assets/resources/icons-submenu/icon1_14.svg'}
    ]},
    {nombre: 'Asesoramiento', backendNombre: 'Asesoramiento', icono: '../assets/resources/icons-menu/asesoramiento.svg', items: [
      {nombre: 'Planos', icono: '../assets/resources/icons-submenu/icon1_15.svg'},
      {nombre: 'Servicio de consultas', icono: '../assets/resources/icons-submenu/icon1_16.svg'}
    ]},
    {nombre: 'Situaciones de emergencia', backendNombre: 'SituacionesDeEmergencia', icono: '../assets/resources/icons-menu/emergencia.svg', items: [
      {nombre: 'Fuga de agua', icono: '../assets/resources/icons-submenu/icon1_17.svg'},
      {nombre: 'Escape de gas', icono: '../assets/resources/icons-submenu/icon1_18.svg'},
      {nombre: 'Tormentas y Vendavales', icono: '../assets/resources/icons-submenu/icon1_19.svg'},
      {nombre: 'Nevadas y Granizos', icono: '../assets/resources/icons-submenu/icon1_20.svg'},
      {nombre: 'Incendio', icono: '../assets/resources/icons-submenu/icon1_21.svg'}
    ]},
  ];
}
